import { AISettings } from "./AISettings";

import { SecondaryOverlay } from "components/constants";
import { CloseOverlayButton } from "components/materials/sidebar/CloseOverlayButton";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useCapabilities } from "store/capability-hooks";
import { useAppDispatch } from "store/index";
import { aiStateActions } from "store/slices/ai";

export const AIChatToolbar = () => {
  const { canUseBetaFeatures } = useCapabilities();
  const dispatch = useAppDispatch();

  return (
    <div className="flex items-center justify-end gap-2">
      {canUseBetaFeatures && <AISettings />}

      <SquareButton
        eventName="AI Assistant - Clear chat"
        kind="tertiary"
        size="s"
        onClick={() => dispatch(aiStateActions.clearAiChatMessages())}
      >
        {t("ai.clear_chat")}
      </SquareButton>

      <CloseOverlayButton focusPanelTrigger={SecondaryOverlay.AIAssistant} />
    </div>
  );
};
